import { Component, computed, effect, EventEmitter, Input, OnInit, Output, signal, ChangeDetectionStrategy } from '@angular/core';
import { InstaLearn, InstaLearnTopic, NodeModel } from '../../../common/models';
import { Observable } from 'rxjs';


@Component({
    selector: 'lib-insta-topic-card',
    templateUrl: './insta-topic-card.component.html',
    styleUrls: ['./insta-topic-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InstaTopicCardComponent implements OnInit {
  @Input() public topic: InstaLearnTopic;
  @Input() public cardsSource: Observable<InstaLearn[]>;

  @Input() public muted = false;

  @Input() set active(value: boolean) {
    this.isTopicActive.set(value);

    if (value) {
      this.hasBeenActivated.set(true);
    }
  }

  @Output() public nextTopic: EventEmitter<void> = new EventEmitter<void>();
  @Output() public prevTopic: EventEmitter<void> = new EventEmitter<void>();
  @Output() public mutedChanged: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() public navigate: EventEmitter<InstaLearn> = new EventEmitter<InstaLearn>();
  @Output() public markAsViewed: EventEmitter<InstaLearn> = new EventEmitter<InstaLearn>();

  public activeCard = computed(() => {
    return this.allCards()[this.activeCardIndex()] ?? null;
  });

  public visibleCards = computed(() => {
    if (this.hasBeenActivated()) {
      return this.allCards();
    }

    const activeCard = this.activeCard();

    return activeCard ? [activeCard] : [];
  });

  public activeCardIndex = signal(0);

  public allCards = signal([]);

  public isTopicActive = signal(false);
  public hasBeenActivated = signal(false);

  constructor() {
    effect(() => {
      const isVisible = this.isTopicActive();
      const card = this.activeCard();

      if (isVisible && card) {
        this.markAsViewed.emit(card);
      }
    });
  }

  ngOnInit(): void {
    if (!this.cardsSource) {
      return;
    }

    this.cardsSource.subscribe(data => {
      this.allCards.set(data);
    });
  }

  public nextStory(): void {
    const index = this.activeCardIndex() + 1;

    if (index >= this.allCards().length) {
      this.nextTopic.emit();
      return;
    }

    this.activeCardIndex.set(index);
  }

  public prevStory(): void {
    const index = this.activeCardIndex() - 1;

    if (index < 0) {
      this.prevTopic.emit();
      return;
    }

    this.activeCardIndex.set(index);
  }

  public cardTap(event: MouseEvent): void {
    if (!this.isTopicActive()) {
      return;
    }

    event.stopPropagation();

    const element = event.currentTarget as HTMLElement;
    const rect = element.getBoundingClientRect();

    const tapX = event.clientX - rect.left;
    const middle = rect.width / 2;

    if (tapX < middle) {
      this.prevStory();
      return;
    }

    this.nextStory();
  }

  public trackById(_index: number, item: InstaLearn): string {
    return item?.id;
  } 
}
